(function($,window,document) {

    'use strict';

    // Setup the event handler
    var handler = {

        /**
        *   @var string
        */
        cookieKey: 'download_events_session',

        /**
        *   Send a custom event to google
        *
        *   @param string name
        *   @param object data
        *
        *   @return Promise
        */
        sendEvent: function(name,data) {
            var pending = true;
            var p = new Promise(function(resolve,reject) {

                // Google Analytics via gtag not loaded, skip
                if( ! window.gtag ) {
                    resolve(false);
                    return;
                }

                // No event name provided, bail early
                if( ! name ) {
                    resolve(false);
                    return;
                }

                // Prepare the event data
                var eventData = $.extend(data || {},{
                    'event_callback': function() {
                        pending = false;
                        resolve(true);
                    },
                });

                // Add default category if not provided
                if( ! eventData.event_category ) {
                    eventData.event_category = 'file';
                }

                // Send the event
                try {
                    window.gtag('event',name,eventData);
                } catch(err) {
                    console.log(err);
                    pending = false;
                    resolve(false);
                    return;
                }

                // Fallback for no response within time limit
                window.setTimeout(function() {
                    if(pending) {
                        pending = false;
                        resolve(false);
                    }
                },1500);

            });

            // Return the promise
            return p;
        },

        /**
        *   Returns the events session cookie object
        *
        *   @return object
        */
        getCookie: function() {
            try {
                return window.JSON.parse(
                    window.decodeURIComponent(
                        document.cookie.split('; ')
                            .find(row => row.startsWith(handler.cookieKey+'='))
                            .split('=')[1] || '{}'
                    )
                );
            } catch(e) {
                return {};
            }
        },

        /**
        *   Returns the events session cookie object
        *
        *   @param object data
        *
        *   @return void
        */
        setCookie: function(data) {
            document.cookie = [
                handler.cookieKey+'='+window.encodeURIComponent(window.JSON.stringify(data)),
                'path=/',
                'SameSite=Lax',
                'Secure',
            ].join('; ');
        },

        /**
        *   Sets a cookie value in events session for given key
        *
        *   @param string key
        *   @param mixed value
        *
        *   @return void
        */
        setCookieValue: function(key,value) {
            var data = handler.getCookie();
            data[key] = value;
            handler.setCookie(data);
        },

        /**
        *   Returns cookie value in events session for given key
        *
        *   @param string key
        *
        *   @return mixed
        */
        getCookieValue: function(key) {
            var data = handler.getCookie();
            return data[key] || null;
        },

        /**
        *   Tracks the download given the event data
        *
        *   @param string name
        *   @param string url
        *   @param object data
        *
        *   @return void
        */
        trackDownload: function(name,url,data) {

            // Send download event
            handler.sendEvent('click_download',data).then( function(success) {
                //console.log('Tracked Download Click: '+url+' - '+(success ? 1 : 0));
            } );

            // No download already found for this session
            if( ! handler.getCookieValue( url ) ) {

                // Send url download event
                handler.sendEvent('url_download',$.extend( {}, data, {
                    event_label: url,
                } ) ).then( function(success) {
                    //console.log('Tracked Session URL Download: '+url+' - '+(success ? 1 : 0));
                } );

                // Record download in session cookie
                handler.setCookieValue( url, 1 );

            }

            // No product recorded download already found for session
            var product_key = data.product_id + '_' + (name || url).replace(/[^a-z0-9\-_]/gi,'-');

            if( ! handler.getCookieValue( product_key ) ) {

                // Send session download event
                handler.sendEvent( 'product_download', data ).then( function(success) {
                    //console.log('Tracked Session Product Download: '+product_key+' - '+(name || download_url)+' - '+(success ? 1 : 0));
                } );

                // Record download in session cookie
                handler.setCookieValue( product_key, 1 );

            }

        },

    };

    // Load event handlers
    $(document).ready(function() {

        // Send Custom Google Event for "download" anytime /my-download link triggered
        $(document).on('my-download','[href*="/my-download/"]',function(e,data) {

            // Load the download url
            var download_url = $(this).attr('href');

            // If download url does not match expected, bail
            if( ! download_url.match(/^.*\/my-download\/([A-Za-z0-9]+)-([0-9]+):([0-9]+):([0-9]+):([0-9]+)\//gi) ) {
                return;
            }

            // Load the url components
            var segments = download_url.replace(/^.*\/my-download\//gi,'').replace(/\/$/gi,'').split(':');
            var hash_key = segments[0].split('-')[0];
            var product_id = segments[0].split('-')[1];
            var order_id = segments[1];
            var user_id = segments[2];
            var time_key = segments[3];

            // Prepare the data
            data = $.extend(data || {},{
                event_label: $(this).data('name') || download_url,
            });

            if( $(this).is('.pdf') ) {
                data.event_category = 'pdf';
            }

            if( $(this).is('.zip') ) {
                data.event_category = 'zip';
            }

            data.download_hash = hash_key;
            data.product_id = product_id;
            data.order_id = order_id;
            data.user_id = user_id;

            // Track the download
            handler.trackDownload( $(this).data('name'), download_url, data );

        });

        // Send download event when subscripton videos are viewed
        $(document).on( 'my-download', 'a.video', function( e, data ) {

            // Load the download url
            var download_url = $(this).attr('href');

            // Prepare the data
            data = $.extend( data || {}, {
                event_label: $(this).data('name') || download_url,
            } );

            if( download_url.match(/youtu\.be/) || download_url.match(/youtube\.com/) ) {
                data.event_category = 'youtube';
            }

            if( download_url.match(/vimeo\.com/) ) {
                data.event_category = 'vimeo';
            }

            if( ! data.event_category ) {
                data.event_category = 'video';
            }

            data.product_id = $(this).data('product-id');
            data.order_id = $(this).data('order-id');
            data.user_id = $(this).data('user-id');

            // Track the download
            handler.trackDownload( $(this).data('name'), download_url, data );

        } );

    } );

})(jQuery,window,document);
